import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getFlagForError, getFlagForSuccess } from '@atlassian/developer-space';
import { addNewContact, patchPartnerContact } from '@atlassian/mpac-api-client';
import { showModalIfTwoSVSessionExpires } from '@atlassian/mpac-ui';
import { log } from '@atlassian/mpac-utils';
import { API_STATUS_ERROR_MESSAGE } from '../../../constants/ErrorMessages';
import { ADD_CONTACT_FAILED, ADD_CONTACT_SUCCESS, ADD_CONTACT_SUCCESS_DESCRIPTION, ADD_TEAM_MEMBER_FAILED, ADD_TEAM_MEMBER_SUCCESS, ADD_TEAM_MEMBER_SUCCESS_DESCRIPTION, EXISTING_TEAM_MEMBER, EXISTING_USER, MANAGE_CONTACT_FAILED, MANAGE_CONTACT_SUCCESS, MANAGE_CONTACT_SUCCESS_DESCRIPTION, MANAGE_TEAM_MEMBER_FAILED, MANAGE_TEAM_MEMBER_SUCCESS, MANAGE_TEAM_MEMBER_SUCCESS_DESCRIPTION, UNKNOWN_TEAM_MEMBER, UNKNOWN_USER } from './AddManageContactModal.label';
import { CONTACT_MODAL_ACTIONS } from './AddManageContactModal.types';
const handleAddContact = async props => {
  try {
    await addNewContact(props.mpacBaseUrl, props.partnerId, props.formData);
    props.onSubmit();
    const flagSuccessDescription = props.showCopyChangesForPartnerContact ? ADD_TEAM_MEMBER_SUCCESS_DESCRIPTION : ADD_CONTACT_SUCCESS_DESCRIPTION;
    props.showFlag(getFlagForSuccess('addContactSuccess', props.showCopyChangesForPartnerContact ? ADD_TEAM_MEMBER_SUCCESS : ADD_CONTACT_SUCCESS, "".concat(props.formData.username, " ").concat(flagSuccessDescription)));
  } catch (error) {
    showModalIfTwoSVSessionExpires(error, props.setTwoStepAuthTimedOut);
    let errorMessage;
    if (error.status === 400) {
      errorMessage = props.showCopyChangesForPartnerContact ? UNKNOWN_TEAM_MEMBER : UNKNOWN_USER;
    } else if (error.status === 409) {
      errorMessage = props.showCopyChangesForPartnerContact ? EXISTING_TEAM_MEMBER : EXISTING_USER;
    } else if (error.status === 401) {
      errorMessage = API_STATUS_ERROR_MESSAGE[401];
    } else {
      log.error('AddManageContactModal', props.showCopyChangesForPartnerContact ? ADD_TEAM_MEMBER_FAILED : ADD_CONTACT_FAILED, {
        error
      });
    }
    props.showFlag(getFlagForError('addContactFailure', props.showCopyChangesForPartnerContact ? ADD_TEAM_MEMBER_FAILED : ADD_CONTACT_FAILED, errorMessage));
  }
};
const showManageContactSuccessFlag = props => {
  props.showFlag(getFlagForSuccess('manageContactSuccess', props.showCopyChangesForPartnerContact ? MANAGE_TEAM_MEMBER_SUCCESS : MANAGE_CONTACT_SUCCESS, props.showCopyChangesForPartnerContact ? MANAGE_TEAM_MEMBER_SUCCESS_DESCRIPTION : MANAGE_CONTACT_SUCCESS_DESCRIPTION));
};
const handleManageContact = async props => {
  if (!props.contact) {
    return;
  }
  const payload = [{
    op: 'replace',
    path: '/permissions',
    value: props.formData.permissions
  }, {
    op: props.contact.roles ? 'replace' : 'add',
    path: '/roles',
    value: props.formData.roles
  }];
  try {
    await patchPartnerContact(props.mpacBaseUrl, props.contact._links.self.href, payload);
    props.onSubmit();
    showManageContactSuccessFlag(_objectSpread({}, props));
  } catch (error) {
    showModalIfTwoSVSessionExpires(error, props.setTwoStepAuthTimedOut);
    if (error.status === 304) {
      props.onSubmit();
      return showManageContactSuccessFlag(_objectSpread({}, props));
    }
    log.error('AddManageContactModal', props.showCopyChangesForPartnerContact ? MANAGE_TEAM_MEMBER_FAILED : MANAGE_CONTACT_FAILED, {
      error
    });
    props.showFlag(getFlagForError('manageContactFailure', props.showCopyChangesForPartnerContact ? MANAGE_TEAM_MEMBER_FAILED : MANAGE_CONTACT_FAILED));
  }
};
const handleSubmit = props => props.action === CONTACT_MODAL_ACTIONS.ADD ? handleAddContact(props) : handleManageContact(props);
export { handleSubmit };